import type { AdminEmailDeliveryListDto, AdminEmailDeliveryQuery } from '@icebreaker/shared';
import { api } from '@/shared/api/client';

/**
 * E-posta gönderim görünümü `api` katmanı — YALNIZCA sagadan çağrılır.
 * Tek uç, tek fiil: sunucuda `staff:audit_read` kapısının arkasında bir `GET`.
 */
export async function fetchEmailDeliveries(
  query: AdminEmailDeliveryQuery,
): Promise<AdminEmailDeliveryListDto> {
  return await api.admin.emailDeliveries({
    status: query.status,
    template: query.template,
    locale: query.locale,
    from: query.from,
    to: query.to,
    page: query.page,
    pageSize: query.pageSize,
  });
}
